// api/getImpactData.js
import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getImpactData = () => {
  return axios.get('/impact'); // returns single document
};

export const useImpactData = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['impact_data'],
    queryFn: () => getImpactData(),
  });
};
